import { render } from "./SharepointTab.vue?vue&type=template&id=f5ab7a98&scoped=true&lang=pug"
import script from "./SharepointTab.vue?vue&type=script&lang=js"
export * from "./SharepointTab.vue?vue&type=script&lang=js"

import "./SharepointTab.vue?vue&type=style&index=0&id=f5ab7a98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ab7a98"]])

export default __exports__